export class Mask {
  static CNPJ = (value: string): string => {
    const x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/)
    let mask = ''
    if (!x) return mask

    if (x[1]) mask += x[1]
    if (x[1] && x[2]) mask += `.${x[2]}`
    if (x[2] && x[3]) mask += `.${x[3]}`
    if (x[3] && x[4]) mask += `/${x[4]}`
    if (x[4] && x[5]) mask += `-${x[5]}`
    return mask
  }

  static CPF = (value: string): string => {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/)
    let mask = ''
    if (!x) return mask

    if (x[1]) mask += x[1]
    if (x[1] && x[2]) mask += `.${x[2]}`
    if (x[2] && x[3]) mask += `.${x[3]}`
    if (x[3] && x[4]) mask += `-${x[4]}`

    return mask
  }

  static CPForCNPJ = (value: string): string => {
    return value.length < 15 ? Mask.CPF(value) : Mask.CNPJ(value)
  }

  static phone = (value: string): string => {
    const phone = value.length > 10 ? value.match(/(\d{0,2})(\d{0,5})(\d{0,4})/) : value.match(/(\d{0,2})(\d{0,4})(\d{0,4})/)

    return phone ? `(${String(phone[1])}) ${String(phone[2])} - ${String(phone[3])}` : ''
  }

  static prefix = (prefix: string, delimited: string, value: string) => {
    const prefixWithDelimited = `${prefix}${delimited}`
    const valueWithoutPrefix = value.replace(prefixWithDelimited, '').replace(prefix, '')
    return !valueWithoutPrefix || valueWithoutPrefix === '' ? prefixWithDelimited : prefixWithDelimited + valueWithoutPrefix
  }

  static suffix = (suffix: string, delimited: string, value: string) => {
    const delimitedWithSuffix = `${delimited}${suffix}`
    const valueWithoutSuffix = value.replace(delimitedWithSuffix, '').replace(suffix, '')
    return !valueWithoutSuffix || valueWithoutSuffix === '' ? delimitedWithSuffix : valueWithoutSuffix + delimitedWithSuffix
  }
}
